export default __webpack_public_path__ + "static/media/waiting_for_payment.0581ce82.svg";